/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NaturePlantFlowerIcon16Light } from './NaturePlantFlowerIcon16Light';
import { NaturePlantFlowerIcon16Regular } from './NaturePlantFlowerIcon16Regular';
import { NaturePlantFlowerIcon16Solid } from './NaturePlantFlowerIcon16Solid';
import { NaturePlantFlowerIcon20Light } from './NaturePlantFlowerIcon20Light';
import { NaturePlantFlowerIcon20Regular } from './NaturePlantFlowerIcon20Regular';
import { NaturePlantFlowerIcon20Solid } from './NaturePlantFlowerIcon20Solid';
import { NaturePlantFlowerIcon24Regular } from './NaturePlantFlowerIcon24Regular';
import { NaturePlantFlowerIcon24Solid } from './NaturePlantFlowerIcon24Solid';
import { NaturePlantFlowerIcon32Regular } from './NaturePlantFlowerIcon32Regular';
import { NaturePlantFlowerIcon64Regular } from './NaturePlantFlowerIcon64Regular';
var sizes = {
    16: {
        light: NaturePlantFlowerIcon16Light,
        regular: NaturePlantFlowerIcon16Regular,
        solid: NaturePlantFlowerIcon16Solid,
    },
    20: {
        light: NaturePlantFlowerIcon20Light,
        regular: NaturePlantFlowerIcon20Regular,
        solid: NaturePlantFlowerIcon20Solid,
    },
    24: {
        regular: NaturePlantFlowerIcon24Regular,
        solid: NaturePlantFlowerIcon24Solid,
    },
    32: {
        regular: NaturePlantFlowerIcon32Regular,
    },
    64: {
        regular: NaturePlantFlowerIcon64Regular,
    },
};
export var NaturePlantFlowerIcon = forwardRef('NaturePlantFlowerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
